import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "handle"]
  static values = {
    isOpen: Boolean
  }

  connect() {
    console.log("LOADED! HEADER");
    // Only show handle on mobile
    if (window.innerWidth < 768) {
      // this.handleTarget.classList.remove("hidden")
      // this.headerTarget.classList.add("-translate-y-full")
      // this.headerTarget.classList.remove("translate-y-0")
      
      // Add scroll event listener
      window.addEventListener("scroll", this.handleScroll.bind(this))
    }
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll.bind(this))
  }

  handleScroll() {
    if (window.scrollY === 0) {
      this.handleTarget.classList.remove("hidden")
    } else {
      this.handleTarget.classList.add("hidden")
    }
  }

  toggle() {
    this.isOpenValue = !this.isOpenValue
    if (this.isOpenValue) {
      this.headerTarget.classList.remove("-translate-y-full")
      this.headerTarget.classList.add("translate-y-0")
      this.updateHeaderVisibility(true)
    } else {
      this.headerTarget.classList.remove("translate-y-0")
      this.headerTarget.classList.add("-translate-y-full")
      this.updateHeaderVisibility(false)
    }
  }

  updateHeaderVisibility(visible) {
    const form = document.querySelector('form')
    if (!form) return

    const formData = new FormData(form)
    formData.append('play_session[layout_settings][header_visible]', visible)
    
    fetch(form.action, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
  }
} 